jQuery(document).ready(function ($) {
  $('.slider-nav').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    focusOnSelect: true,
    prevArrow: '<button type="button" class="slick-prev"><img src="https://netmastertech.com/demos/fujienviromax/wp-content/uploads/2025/10/arrow-left.svg" alt="Previous"></button>',
    nextArrow: '<button type="button" class="slick-next"><img src="https://netmastertech.com/demos/fujienviromax/wp-content/uploads/2025/10/arrow-right-1.svg" alt="Next"></button>'
  });
});


jQuery(document).ready(function ($) {
  $('.collection-nav').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 4000,
    focusOnSelect: true,
     responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 991, 
        settings: {
          slidesToShow: 4,
        }
      },
       {
        breakpoint: 767, 
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480, 
        settings: {
          slidesToShow: 2
        }
      }
    ],
    prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0997/6522/3755/files/Group_4.svg?v=1765802268" alt="Previous"></button>',
    nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0997/6522/3755/files/Group_5.svg?v=1765802265" alt="Next"></button>'
  });
});


jQuery(document).ready(function ($) {
  $('.brands-slide').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    speed: 6000,              
    autoplay: true,
    autoplaySpeed: 0,        
    cssEase: 'linear',    
    infinite: true,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    pauseOnFocus: false,
     responsive: [
      {
        breakpoint: 991, 
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 575, 
        settings: {
          slidesToShow: 2
        }
      }
    ],
    swipe: false,
    draggable: false
  });
});


jQuery(document).ready(function ($) {
  function initMobileSlider() {
    if ($(window).width() < 767) {

      if (!$('.icon-boxes-slider').hasClass('slick-initialized')) {
        $('.icon-boxes-slider').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          autoplay: true,
          responsive: [
      {
        breakpoint: 575, 
        settings: {
          slidesToShow: 2,
        }
      }
    ],
          autoplaySpeed: 4000,
          focusOnSelect: true,
        });
      }

    } else {

      if ($('.icon-boxes-slider').hasClass('slick-initialized')) {
        $('.icon-boxes-slider').slick('unslick');
      }

    }
  }
  initMobileSlider();
  $(window).on('resize', initMobileSlider);

});



jQuery(document).ready(function ($) {
  $('.sub-categories-product').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 4000,
    focusOnSelect: true,
     responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 991, 
        settings: {
          slidesToShow: 4,
        }
      },
       {
        breakpoint: 767, 
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480, 
        settings: {
          slidesToShow: 2
        }
      }
    ],
    prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0997/6522/3755/files/Group_4.svg?v=1765802268" alt="Previous"></button>',
    nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0997/6522/3755/files/Group_5.svg?v=1765802265" alt="Next"></button>'
  });
});



document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tab-btn");
  const contents = document.querySelectorAll(".tab-content");

  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      tab.classList.add("active");
      document.getElementById(tab.dataset.tab).classList.add("active");
    });
  });
});



document.addEventListener('DOMContentLoaded', function () {
  const PLUS_ICON = 'https://cdn.shopify.com/s/files/1/0997/6522/3755/files/plus.svg?v=1766149492';
  const MINUS_ICON = 'https://cdn.shopify.com/s/files/1/0997/6522/3755/files/Line_3.svg?v=1766149632';

  document.querySelectorAll('.static-faq__question').forEach(btn => {
    // Create icon
    const icon = document.createElement('span');
    icon.className = 'static-faq__icon';
    icon.innerHTML = `<img src="${PLUS_ICON}" alt="plus">`;
    btn.appendChild(icon);

    btn.addEventListener('click', function () {
      const currentItem = btn.closest('.static-faq__item');
      if (!currentItem) return;

      const isOpen = currentItem.classList.contains('active');

      // Close all open FAQs
      document.querySelectorAll('.static-faq__item.active').forEach(item => {
        item.classList.remove('active');
        const itemIcon = item.querySelector('.static-faq__icon img');
        if (itemIcon) {
          itemIcon.src = PLUS_ICON;
          itemIcon.alt = 'plus';
        }
      });

      // Open clicked one (if it was closed)
      if (!isOpen) {
        currentItem.classList.add('active');
        icon.querySelector('img').src = MINUS_ICON;
        icon.querySelector('img').alt = 'minus';
      }
    });
  });
});
